export class VcuAttributes {
    tags?: string;
    model?: number | string;
    reasonUnlink?: string;

    constructor(
        tags?: string[],
        model?: number | string,
        reasonUnlink?: string
    ) {
        this.tags = tags?.join(",");
        this.model = model;
        this.reasonUnlink = reasonUnlink;
    }
}
